export default "__VITE_ASSET__e$EBfuXC__"